// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"confirmationModal_wrapper__NFPUR","text":"confirmationModal_text__LXWur","actions":"confirmationModal_actions__xeapU"};